import React from 'react';
import { useTranslation } from 'react-i18next';
interface IProps {
  count: number;
  searchTerm?: string;
}

/* prettier-ignore */
const SearchFeedback: React.FC<IProps> = (props) => {
    const { t } = useTranslation();
    const { count } = props;

    return (<div data-testid='search-feedback'>
        {count === 0 && <div className='flex text-primary-2 leading-7 flex-col justify-center items-center'>
            <span className='text-lg font-normal'>{t('No banks found for')} "{props.searchTerm || ""}"</span>
            <span className='text-md font-normal'>{t('Please adjust your search term')}</span>
        </div>}

        {count === 1 && (
            <p>{t<string>('Found {{count}} bank', { count: count })}:</p>
        ) }

        {count > 1 && (
            <p>{t<string>('Found {{count}} banks', {
                count: count
            })}:</p>
        ) }

    </div>);
};

export default SearchFeedback;
